module.exports = __webpack_public_path__ + "static/media/ui_yes.2ef7efe3.svg";